/**
 * utils - calculations
 */
// TODO: put in shared module (source code from mobile)
export const averageInteger = (integers: number[]): number => {
    const total = integers.reduce((result, next) => result + next, 0);
    return Number((total / integers.length).toFixed(2));
};

export const averageFloat = averageInteger;

export const averageBoolean = (booleans: boolean[]): string => {
    if (booleans.length === 1) {
        return booleans[0] ? 'Yes' : 'No';
    }

    const total = booleans.reduce((result, next) => {
        if (next) {
            return result + 1;
        }

        return result;
    }, 0);

    return `${Number((total / booleans.length).toFixed(2)) * 100}%`;
};

type Value = string | number | null | undefined;
export const joinValues = (values: Value[]): string =>
    values
        .filter((item) => !(['', null, undefined] as Value[]).includes(item))
        .join(', ');
